<app-loader *ngIf="loaderService.loading"></app-loader>
<app-slide-menu *ngIf="slideMenuService.showed"></app-slide-menu>
<router-outlet></router-outlet>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>